import { Component } from '@angular/core';

import { IWebcastViewContext } from 'rev-shared/webcast/webcastView/IWebcastViewContext';

import { VbWebcastManageQuestionSidebarComponent } from './VbWebcastManageQuestionSidebar.Component';
import './VbWebcastManageQuestionFullscreen.Component.less';

@Component({
	selector: 'vb-webcast-manage-question-fullscreen',
	templateUrl: './VbWebcastManageQuestionFullscreen.Component.html',
	host: {
		'class': 'questionsFullscreenHost theme-primary'
	},
	standalone: false
})
export class VbWebcastManageQuestionFullscreenComponent extends VbWebcastManageQuestionSidebarComponent {
	public readonly context: IWebcastViewContext = { titleCase: true };
}
